

import React, { useEffect } from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";

const PopupUI = ({ popupContent, isAdd, isUpdate, handleClose, title}) => {
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  return (
    <Modal
      title={<p className="font-bold ">{title}</p>} 
      open={isAdd || isUpdate}
      onCancel={handleClose}
      footer={null}
      className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
    
    >
      <div className="form-input-details space-y-2 px-2 flex justify-center border p-3">
        {popupContent}
      </div>
    </Modal>
  );
};

export default PopupUI;










